module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/first_abcaabf00fd5107031868775fd741dfc.png";